//--------------------
// save current runes
//--------------------
export default function saveCurrentRunes(runes) {
  // ----------------------
  // check got rune array
  // ----------------------
  if (!Array.isArray(runes)) return null
  //--------------------------------------------------------------------
  // create array with specified props (editable or keys) for each rune
  //--------------------------------------------------------------------
  const original_runes = runes.map((rune) => ({
    name: rune.name, // for debug only
    id: rune?.id ?? null, // character rune id if existing (should be there)
    strength: rune.strength,
    pwr_storage: rune.pwr_storage,
    starter: rune.starter,
    integrated: rune.integrated,
    character_item: rune.character_item,
    notes: rune.notes,
  }))
  return original_runes
}
